module.exports = __webpack_public_path__ + "static/media/General_settings.2bf3fea4.svg";